
import { Link } from "react-router-dom";
import aabbLogo from "@/assets/aabb-logo.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary-dark text-white">
      <div className="container mx-auto py-8 px-4">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="opacity-75 hover:opacity-100" aria-label="Navigate to home page">Home</Link></li>
              <li><Link to="/#about" className="opacity-75 hover:opacity-100" aria-label="Navigate to about us section">About Us</Link></li>
              <li><Link to="/dna-pricing" className="opacity-75 hover:opacity-100" aria-label="Navigate to DNA testing page">DNA Testing</Link></li>
              <li><Link to="/drug-testing" className="opacity-75 hover:opacity-100" aria-label="Navigate to drug testing page">Drug Testing</Link></li>
              <li><Link to="/gender-reveal" className="opacity-75 hover:opacity-100" aria-label="Navigate to gender reveal page">Gender Reveal</Link></li>
              <li><Link to="/biometric-screening" className="opacity-75 hover:opacity-100" aria-label="Navigate to biometric screening page">Biometric Screening</Link></li>
              <li><Link to="/booking" className="opacity-75 hover:opacity-100" aria-label="Navigate to booking page">Book Appointment</Link></li>
              <li><Link to="/#contact" className="opacity-75 hover:opacity-100" aria-label="Navigate to contact section">Contact Us</Link></li>
              <li>
                <Link to="/social" className="opacity-75 hover:opacity-100" aria-label="Follow us on social media">
                  Follow Us on Social Media
                </Link>
              </li>
              <li>
                <Link to="/affiliate" className="opacity-75 hover:opacity-100" aria-label="Learn about our partner program">
                  Partner Program
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="tel:7135104442" className="opacity-75 hover:opacity-100" aria-label="Call us at 713-510-4442">
                  Phone: 7135104442
                </a>
              </li>
              <li>
                <a href="mailto:info@nearlabservices.com" className="opacity-75 hover:opacity-100" aria-label="Send email to info@nearlabservices.com">
                  Email: info@nearlabservices.com
                </a>
              </li>
              <li>
                <a href="mailto:affiliate@nearlabservices.com" className="opacity-75 hover:opacity-100" aria-label="Contact affiliate program at affiliate@nearlabservices.com">
                  Affiliate Program: affiliate@nearlabservices.com
                </a>
              </li>
              <li><a href="#" className="opacity-75 hover:opacity-100" aria-label="Read our privacy policy">Privacy Policy</a></li>
              <li><a href="#" className="opacity-75 hover:opacity-100" aria-label="Read our terms of service">Terms of Service</a></li>
              <li><a href="#" className="opacity-75 hover:opacity-100" aria-label="View HIPAA compliance information">HIPAA Compliance</a></li>
              <li><a href="#" className="opacity-75 hover:opacity-100" aria-label="Read our cookie policy">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-col gap-6">
            {/* Partnership Logos Section */}
            <div className="flex flex-col items-center gap-3">
              <h4 className="text-sm font-semibold opacity-90">Laboratory Partners</h4>
              <div className="flex flex-wrap items-center justify-center gap-6">
                <div className="flex items-center gap-2">
                  <img src={aabbLogo} alt="AABB Accredited Laboratory" className="h-8 w-auto" />
                  <span className="text-xs opacity-75">AABB Certified</span>
                </div>
                {/* DDC Logo */}
                <div className="flex items-center gap-2">
                  <img src="/lovable-uploads/6ed6adfd-5b18-4524-a784-977c7efa2517.png" alt="DNA Diagnostic Centre (DDC)" className="h-8 w-auto" />
                </div>
                {/* BBB Badge */}
                <div className="flex items-center gap-2">
                  <a
                    href="https://www.bbb.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Better Business Bureau Accredited Business"
                    className="flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity"
                  >
                    <div className="flex flex-col items-center justify-center bg-white rounded px-2 py-1">
                      <span className="text-[10px] font-bold text-primary-dark leading-tight">BBB</span>
                      <span className="text-[8px] text-primary-dark leading-tight">ACCREDITED</span>
                      <span className="text-[8px] text-primary-dark leading-tight">BUSINESS</span>
                    </div>
                    <span className="text-xs opacity-75">BBB Accredited</span>
                  </a>
                </div>
              </div>
            </div>
            
            {/* Copyright */}
            <div className="flex justify-center">
              <p className="text-sm opacity-75">&copy; {currentYear} NearLab Services LLC. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
